module.exports = __webpack_public_path__ + "images/topics/mammals/animal_parts_and_engineering.png";